export default "__VITE_ASSET__h$KiJW_i__"